import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

/**
 * global vuex store
 */
export default new Vuex.Store({
    state: {
        // general
        os: '',
        deviceId: '',
        // url params
        customer: '',
        languageId: '',
        languageIdIntern: "",
        userHash: '',
        webformHash: '',
        urlParams: [],


    },
    mutations: {
        // general
        setOs(state,payload) {
            state.os = payload;
        },
        setDeviceId(state,payload) {
            state.deviceId = payload;
        },
        // url params
        setCustomer(state, payload) {
            state.customer = payload;
        },
        setLanguageId(state, payload) {
            state.languageId = payload;
        },
        setLanguageIdIntern(state, payload) {
            state.languageIdIntern = payload;
        },
        setUserHash(state, payload) {
            state.userHash = payload;
        },
        setWebformHash(state, payload) {
            state.webformHash = payload;
        },
        setUrlParams(state, payload) {
            state.urlParams = payload;
        },


    },
    actions: {},
    modules: {},
    getters: {
        // general
        getOs: state => state.os,
        getDeviceId: state => state.deviceId,
        // url params
        getCustomer: state => state.customer,
        getLanguageId: state => state.languageId,
        getLanguageIdIntern: state => state.languageIdIntern,
        getUserHash: state => state.userHash,
        getWebformHash: state => state.webformHash,
        getUrlParams: state => state.urlParams


    },
})
